import React from 'react'
import { Paper, Grid, Typography, TextField } from '@the-platform-group/component-library'

const JobsListWrapper = ({ title, searchTerm, setSearchTerm, action, children }) => {
  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  return (
    <Paper sx={{ height: '100%', p: 2 }}>
      <Grid container spacing={1}>
        <Grid item container xs={12} justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="subtitle1" fontWeight="bold">
              {title}
            </Typography>
          </Grid>
          {action && <Grid item>{action}</Grid>}
        </Grid>

        <Grid item xs={12}>
          <TextField
            placeholder="Search jobs..."
            value={searchTerm}
            onChange={handleSearchChange}
            fullWidth
            size="small"
            variant="outlined"
          />
        </Grid>
        {children}
      </Grid>
    </Paper>
  )
}

export const NoJobsAvailable = () => {
  return (
    <Grid item xs={12}>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        No jobs available
      </Typography>
    </Grid>
  )
}

export const NoJobsMatchSearch = () => {
  return (
    <Grid item xs={12}>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        No jobs match your search
      </Typography>
    </Grid>
  )
}

export default JobsListWrapper
